import Query from "@qpr/client-api-base/querybuilder/Query";
import defaultAttributes from "./defaultAttributes";
import { ICardElementWithChildren, IPeriod, IPeriodLevel } from "./model/model";
import { matchElementPeriodToRequestedPeriod } from "./model/matchElementPeriodToRequestedPeriod";
import { convertItemListToPeriod } from "./model/convertItemListToPeriod";

function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}
const getValues = async (
  elementId: string | string[],
  periods: IPeriod[],
  notExactPeriod = false,
  periodLevels: IPeriodLevel[]
): Promise<Array<ICardElementWithChildren>> => {
  const allPeriods = [...periods];
  const valuesPromise: Promise<ICardElementWithChildren | null>[] = [];

  // TODO: use matchElementPeriodToRequestedPeriod to map the elements period
  // to correct period level for the element, this is a bit tricky thing to do I think...

  allPeriods.forEach((period) => {
    const elementIdList = Array.isArray(elementId) ? elementId : [elementId];

    elementIdList.forEach((id) => {
      valuesPromise.push(
        Query(id)
          .attributes(...defaultAttributes(period.name, periodLevels))
          .fetchValues<ICardElementWithChildren>()
          .then((valuelist) => {
            return convertItemListToPeriod(valuelist, period, periodLevels);
          })
          .then((valuelist) => {
            const [res] = valuelist;
            if (res.periodlevel !== period.periodlevel && !notExactPeriod) {
              return null;
            }
            return {
              ...res,
              //period: period,
              //children: [],
            };
          })
      );
    });
  });
  const valuesFrom = await (await Promise.all(valuesPromise)).filter(notEmpty);
  return valuesFrom;
};
export default getValues;
